export const SET_OVERVIEW = 'SET_OVERVIEW';
export const RESET_OVERVIEW = 'RESET_OVERVIEW';
export const SET_OVERVIEW_IS_LOADING = 'SET_OVERVIEW_IS_LOADING';
export const RESET_OVERVIEW_IS_LOADING = 'RESET_OVERVIEW_IS_LOADING';
export const SET_OVERVIEW_ERROR = 'SET_OVERVIEW_ERROR';
export const RESET_OVERVIEW_ERROR = 'RESET_OVERVIEW_ERROR';
